import { useAnalytics } from "@codat/analytics";
import { TextLink as OrchardTextLink } from "@codat/orchard-ui";
import { TextLinkProps as OrchardTextLinkProps } from "@codat/orchard-ui/dist/es/components/TextLink";

interface TextLinkProps extends Omit<OrchardTextLinkProps, "ref"> {
  analyticsName: string;
  eventProperties?: object;
}

export const TextLink = (props: TextLinkProps) => {
  const { analyticsName, eventProperties, onClick, children, ...linkProps } =
    props;

  const analytics = useAnalytics();

  const onAmplitudeEventSent = () => {
    if (!props.href) return;
    window.location.assign(props.href);
  };

  const handleOnClickWithTracking = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    const eventName = `${analyticsName} link - Clicked`;

    if (onClick) {
      analytics.sendEvent(eventName, eventProperties);
      onClick(e);
      return;
    }

    if (!analytics) {
      return;
    }

    if (props.href && props.target !== "_blank") {
      e.preventDefault();

      // If link is opened in same tab, we must use callback to ensure event is sent before navigating away
      analytics.sendEvent(
        eventName,
        eventProperties,
        onAmplitudeEventSent,
        onAmplitudeEventSent
      );
    } else {
      // If not a link or if link is opened in new tab, we don't need to wait for Amplitude to complete before handling navigation
      analytics.sendEvent(eventName, eventProperties);
    }
  };

  return (
    <OrchardTextLink {...linkProps} onClick={handleOnClickWithTracking}>
      {children}
    </OrchardTextLink>
  );
};
